const values = [
  {
    icon: "ri-crosshair-2-line",
    title: "网站定位",
    desc: "嘿咻嘿咻漫画读者的一站式信息站，聚焦剧情脉络、结局考据、角色档案与读者讨论，让追更更轻松、更深入。",
  },
  {
    icon: "ri-seedling-line",
    title: "发展理念",
    desc: "我们相信好故事值得被认真读懂。坚持「内容优先、克制表达」，不追热点噪音，只做经得起二刷推敲的解读。",
  },
  {
    icon: "ri-edit-line",
    title: "内容原则",
    desc: "每一篇解析都基于原作分镜与台词，拒绝脑补式过度解读；标注观点与考据边界，尊重不同读者的理解。",
  },
  {
    icon: "ri-team-line",
    title: "社区共创",
    desc: "读者圆桌与讨论区欢迎每一个声音。好的解读来自多元视角，我们鼓励理性交流，共同把故事看得更透。",
  },
];

const principles = [
  { title: "尊重原作", desc: "所有分析以原作分镜、台词与官方设定为依据。" },
  { title: "克制不剧透", desc: "导读类内容会标明剧透范围，保护新人体验。" },
  { title: "多元视角", desc: "结局开放理解，我们呈现多角度讨论而非唯一答案。" },
  { title: "持续跟进", desc: "番外与消息动态，我们会第一时间整理更新。" },
];

function AboutMain() {
  return (
    <section className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-16">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-2">
        <div>
          <span className="inline-flex items-center gap-2 text-xs font-medium text-primary-700">
            <i className="ri-book-open-line"></i> 品牌介绍
          </span>
          <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950">
            让每一个追更的灵魂，都不孤单
          </h2>
          <p className="mt-4 text-sm leading-7 text-foreground-700">
            嘿咻嘿咻漫画用温柔的日常讲述了成长与告别的故事，而我们的任务，就是帮读者把这些温柔的细节一格格读透。这里既有快速上手的剧情速览，也有反复推敲的结局考据，更有来自读者的真实口碑与讨论。
          </p>
          <p className="mt-4 text-sm leading-7 text-foreground-700">
            我们拒绝空泛的标题党，也拒绝机械的搬运。每一篇文章，都希望经得起二刷对照；每一个栏目，都希望能真正帮到你——无论你是刚入坑的新人，还是追更多年的老读者。
          </p>
          <img
            src="https://readdy.ai/api/search-image?query=Stylized%20editorial%20manga%20illustration%20of%20a%20warm%20cozy%20reading%20nook%20with%20stacked%20comic%20books%20and%20a%20steaming%20mug%20under%20soft%20lamp%20light%2C%20warm%20vermilion%20and%20cream%20ink%20palette%20with%20halftone%20dots%20and%20brush%20texture%2C%20inviting%20reading%20mood%2C%20high%20detail&width=900&height=600&seq=about-main&orientation=landscape"
            alt="品牌介绍：温暖的阅读角落插画"
            className="mt-8 w-full rounded-lg object-cover object-top"
          />
        </div>

        <div className="space-y-4">
          {values.map((v) => (
            <div key={v.title} className="flex gap-4 rounded-lg border border-background-200/70 bg-background-50 p-5">
              <span className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-md bg-secondary-500 text-background-50">
                <i className={`${v.icon} text-lg`}></i>
              </span>
              <div>
                <h3 className="font-heading text-base font-bold text-foreground-950">{v.title}</h3>
                <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{v.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="mt-16 rounded-lg bg-secondary-100 p-6 md:p-10">
        <div className="grid grid-cols-1 items-center gap-8 lg:grid-cols-[1.2fr_1fr]">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-secondary-200 px-3 py-1 text-xs font-medium text-secondary-800">
              <i className="ri-check-double-line"></i> 内容原则
            </span>
            <h2 className="mt-4 font-heading text-2xl font-bold text-foreground-950">
              我们如何做内容
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              四条朴素的原则，贯穿我们创作的每一篇文章、每一个栏目。
            </p>
          </div>
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            {principles.map((p) => (
              <div key={p.title} className="rounded-lg bg-background-50 p-4">
                <span className="flex h-8 w-8 items-center justify-center rounded-full bg-primary-100 text-primary-700">
                  <i className="ri-check-line"></i>
                </span>
                <h3 className="mt-3 text-sm font-semibold text-foreground-950">{p.title}</h3>
                <p className="mt-1 text-xs leading-relaxed text-foreground-600">{p.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutMain;